import { createApp } from "vue";
import VueSelect from "vue-select";
import { plugin, defaultConfig } from '@formkit/vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import ContactForm from "./pages/ContactForm.vue";
import "vue-select/dist/vue-select.css";

const getRandomId = (): string => {
  const randomStrBase = "privacyhub-vue-";
  const randomId = Math.floor(Math.random() * 100000000).toString();
  return randomStrBase.concat(randomId);
};

const createMountPoint = (selector: HTMLElement, selectorId: string): void => {
  selector.setAttribute("id", selectorId);
};

const getVueMountPoint = (mountPoint: string): string => {
  return '#'.concat(mountPoint);
};

const findEmbeds = (): NodeListOf<HTMLElement> => {
  const mountSelector = "[data-id='privacyhub-vue']";
  return document.querySelectorAll(mountSelector);
};

const getStartPage = (foundEmbed: HTMLElement): string | false => {
  if (!foundEmbed) return false;
  const page = foundEmbed.dataset?.page;
  return page ?? false;
};

const getQuery = (foundEmbed: HTMLElement): string => {
  const query = foundEmbed.dataset?.query;
  return query ?? '';
};

const getFolder = (foundEmbed: HTMLElement): string => {
  const folder = foundEmbed.dataset?.folder;
  return folder ?? '';
};

const initVueOnEmbed = (foundEmbed:HTMLElement): void => {
  const startPage = getStartPage(foundEmbed);
  if (!startPage) return;

  const query = getQuery(foundEmbed);
  const folder = getFolder(foundEmbed);

  const embedMountId = getRandomId();
  createMountPoint(foundEmbed, embedMountId);

  const vueMountPoint = getVueMountPoint(embedMountId);
  const app = createApp(App, { startPage, query, folder });

  app.component('ContactForm', ContactForm);
  app.component("v-select", VueSelect);

  app.use(createPinia());
  app.use(plugin, defaultConfig);

  app.mount(vueMountPoint);
};

(() => {
  const foundEmbeds = findEmbeds();
  foundEmbeds.forEach((foundEmbed) => {
    initVueOnEmbed(foundEmbed);
  });
})();
